// Windows Load Handler

(function($) {

    $(window).on('load', function(){


    });

}(jQuery));